export default __webpack_public_path__ + "static/media/banner-12.8994abf5.png";